"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _isNativeBorder = _interopRequireDefault(require("../utils/isNativeBorder"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    width: 100%;\n    min-width: 100%;\n    margin: 0;\n    position: relative;\n    display: block;\n    border-style: ", ";\n    border-width: ", ";\n    transition-property: color, border, boxShadow, background;\n    box-sizing: border-box;\n\n    ::placeholder,\n    ::-webkit-input-placeholder {\n        color: ", ";\n        transition-duration: ", ";\n        transition-timing-function: ", ";\n        transition-property: color;\n    }\n\n    :-ms-input-placeholder {\n        color: ", ";\n        transition-duration: ", ";\n        transition-timing-function: ", ";\n        transition-property: color;\n    }\n\n    &:focus {\n        outline: 0 none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _styledComponents["default"].input(_templateObject(), function (props) {
  return props.theme;
}, function (props) {
  return (0, _isNativeBorder["default"])(props.theme.borderStyle) ? props.theme.borderStyle : 'none';
}, function (props) {
  return (0, _isNativeBorder["default"])(props.theme.borderStyle) ? props.theme.borderWidth : '0';
}, function (props) {
  return props.theme.placeholder;
}, function (props) {
  return props.theme.transitionDuration;
}, function (props) {
  return props.theme.transitionFunction;
}, function (props) {
  return props.theme.placeholder;
}, function (props) {
  return props.theme.transitionDuration;
}, function (props) {
  return props.theme.transitionFunction;
});

var _default = Root;
exports["default"] = _default;